export default "__VITE_ASSET__16ac43ef__"